<template>
  <div id="app" />
</template>

<script>
import common from "@/utils/common.js";
export default {
  name: "index",

  created() {
    this.checkTokenUrl();
  },
  methods: {
    checkTokenUrl() {
      console.log(this.$route.params)
      if (this.$route.params.isfirst == "first") {
        if (this.$route.params.states == "login") {
          var http = common.httplogin + encodeURI(common.http + "index/second/login");
          window.open(http, "_self");
        } else if (this.$route.params.states == "auto") {
          var http = common.httpauto + encodeURI(common.http + "index/second/auto");
          window.open(http, "_self");
        } else if (this.$route.params.states == "regist") {
          var http = common.httpregist + encodeURI(common.http + "index/second/regist");
          window.open(http, "_self");
        }
      } else {
        var httpurl = localStorage.getItem("islogin_httpurl") || "";
        if (httpurl == "") {
          httpurl = common.http;
        }
        window.location.replace(httpurl);
      }
    },
    loginData(token) {
      var that = this;
      this.getRequest('api/v1/login', {
        token: token
      }).then(data => {
        if (data.IsSuccess) {
          common.userBase = data.Data;
        } else {
          common.userBase = null;
          this.loginOut();
        }
      })

    },
    loginOut() {
      common.userBase = null;
      var http = common.httploginout + encodeURI(window.location.href);
      window.open(http, '_self');
    },
  },
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

body {
  background: #ffffff;
  padding: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue